// extracted by mini-css-extract-plugin
export default {"root":"B4uwJ","title":"ioBJ5","buttons":"zqjE_"};